const RequiredLabel = ({ id, children }) => (
  <label id={id}>
    <span style={{ color: "#f44336", marginRight: 2 }}>*</span>
    {children}
  </label>
);

export default RequiredLabel;
